import React, { useEffect } from 'react';

import { HeaderPortalContext } from './portal-provider';

const PortalDestination = ({ children, setHeaderPortalContext }) => {
  useEffect(() => {
    setHeaderPortalContext({
      children,
    });

    return () =>
      setHeaderPortalContext({
        children: null,
      });
  }, [children, setHeaderPortalContext]);

  return null;
};

export default ({ children }) => (
  <HeaderPortalContext.Consumer>
    {({ setHeaderPortalContext }) => (
      <PortalDestination setHeaderPortalContext={setHeaderPortalContext}>
        {children}
      </PortalDestination>
    )}
  </HeaderPortalContext.Consumer>
);
